var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechatAuthorize_m_container"},[_c('p',{staticClass:"tip-text"},[_vm._v("为了您的账户安全，请绑定您的微信")]),_c('z-button',{staticClass:"bind-btn",attrs:{"type":"primary","text":"绑定微信账户"},on:{"click":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }